import React from "react";
import { Button } from "@chakra-ui/react";
import ClientsTable from "./ClientsTable";
import UsersFilter from "../UsersFilter";
import ContentCard from "../../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import Body from "../../Common/Body";

const Sellers = () => {
  const history = useHistory();
  return (
    <Body title={"Lista de clientes"}>
      <ContentCard>
        <UsersFilter role={4}></UsersFilter>
      </ContentCard>
      <ContentCard>
        <Button
          my="2"
          colorScheme="blue"
          onClick={() => history.push("/usuarios/nuevo?roleId=4")}
        >
          + Cliente
        </Button>
        <ClientsTable></ClientsTable>
      </ContentCard>
    </Body>
  );
};

export default Sellers;
